import tw from 'twin.macro'
import 'styled-components/macro'
import { ReactNode } from 'react'

export const LiBox = tw.li`
  border border-default-neutral
  p-5
  flex flex-col justify-around
  h-56
`

export const Rule = tw.span`text-critical-neutral`

export function Spec({
  config,
}: {
  config: { fontSize: string; fontWeight: number; lineHeight: string }
}) {
  return (
    <ul tw="bg-default-muted p-1 pl-2">
      <pre>
        <li>
          <Rule>font-size:</Rule> {config.fontSize};
        </li>
        <li>
          <Rule>line-height:</Rule> {config.lineHeight};
        </li>
        <li>
          <Rule>font-weight:</Rule> {config.fontWeight};
        </li>
      </pre>
    </ul>
  )
}

export function ClassName({ children }: { children: ReactNode }) {
  return (
    <div>
      <code tw="font-medium">{children}</code>
    </div>
  )
}
